import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScriptAd = ({ scriptUrl }) => {
    const location = useLocation();

    useEffect(() => {
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, [location.pathname, scriptUrl]);

    // Script-only ads don't need a visible HTML container
    return null;
};

export default ScriptAd;